const ignoredElements = ['isapplepay', 'klarna-express-button', 'side-drawer', 'sr-header'];

module.exports = {
    ignoredElements
};
